import React, {useContext} from 'react';
import Form from "react-bootstrap/Form";
import Icon from "@reacticons/bootstrap-icons";
import {Context} from "../../index";

const ContainerRowOutputOutCar = (props) => {
    const {store} = useContext(Context);
    const row = props.row;

    return (
        <tr>
            <td>{props.index + 1}</td>
            <td>
                <Form.Select value={row.type ?? ''} onChange={event => props.handleChange(event.target.value, 'type', props.index)} required>
                    <option value=""></option>
                    {store.typeOut.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                </Form.Select>
            </td>
            <td>
                <Form.Control
                    value={row.count ?? 1}
                    onChange={event => props.handleChange(event.target.value, 'count', props.index)}
                    type="number"
                    min="1"
                    step="1"
                    required
                />
            </td>
            <td>
                {!props.del ? null :
                    <a href="#" className="text-warning" onClick={event => props.delete(event, props.index)}>
                        <Icon name="trash"/>
                    </a>
                }
            </td>
        </tr>
    );
};

export default ContainerRowOutputOutCar;
